module.exports = __webpack_public_path__ + "media/images/favicon/favicon-477bbdf2e77bd7192cb9e1f08f1dd5ad.ico";